import { useState, useRef, useEffect, UIEvent } from 'react';

export function useTermsScroll(open: boolean, terms: string) {
  const [checked, setChecked] = useState(false);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // If the content is small enough that it doesn't need scrolling, unlock immediately.
    // Also reset scroll state when modal opens or terms change.
    if (!open) {
      setHasScrolledToBottom(false);
      setChecked(false);
      return;
    }
    
    // Give DOM a small tick to render the innerHTML
    const timer = setTimeout(() => {
      if (scrollRef.current) {
        const { scrollHeight, clientHeight } = scrollRef.current;
        if (scrollHeight <= clientHeight + 10) {
          setHasScrolledToBottom(true);
        }
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [terms, open]);

  const handleScroll = (e: UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    const isAtBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 10;
    setHasScrolledToBottom(isAtBottom);
    if (!isAtBottom) {
      setChecked(false);
    }
  };

  return {
    checked,
    setChecked,
    hasScrolledToBottom,
    scrollRef,
    handleScroll,
  };
}
